/**
 * Audit log request/response shapes (Phase 3, M3.8).
 *
 * The audit log is append-only and tenant-scoped. Significant operations
 * (agent CRUD, secret reads/writes, member changes, run triggers) are logged.
 */
import { z } from "zod";
import { IsoTimestampSchema } from "./common.js";
export const AuditEventSchema = z.object({
    id: z.string().uuid(),
    actor_display: z.string(),
    event_type: z.string(),
    resource_type: z.string().nullable(),
    resource_id: z.string().nullable(),
    payload: z.record(z.unknown()),
    occurred_at: IsoTimestampSchema,
});
export const AuditListResponseSchema = z.object({
    items: z.array(AuditEventSchema),
    next_cursor: IsoTimestampSchema.nullable(),
});
//# sourceMappingURL=audit.js.map